import React, { useState, useEffect } from "react";
import Text from "./asset/file/text.txt";
import apiUrl from "./asset/file/apiUrl.txt";
import Json from "./asset/file/object.json";
import reactLogo from "./asset/img/reactlogo.png";
import IndexPage from "./Pages/IndexPage";
import MdPage from "./Pages/MDPage";
import { Row, Col, Nav, Container } from "react-bootstrap";
import Header from "./components/Header";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  const [mdName, SetMdDir] = useState<string>("");
  return (
    <BrowserRouter>
      <Container id="indexPageWrapper" fluid>
        <Row>
          <Header></Header>
        </Row>
        <Row className="d-flex justify-content-center">
          <Routes>
            <>
              <Route path="/md/:mdName" element={<MdPage></MdPage>}></Route>
            </>
            <>
              <Route path="/" element={<IndexPage></IndexPage>}></Route>
            </>
            </Routes>
        </Row>
      </Container>
    </BrowserRouter>
  );
}

export default App;
